import { render } from "./AddLivraisonPage.vue?vue&type=template&id=0864e7a3&ts=true"
import script from "./AddLivraisonPage.vue?vue&type=script&lang=ts"
export * from "./AddLivraisonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__